import { Input as StrapInput } from 'reactstrap';
import styled from 'styled-components';

const Input = styled(StrapInput)`
    /* Bootstrap 5 compatibility - ensure proper form control styling */
    display: block !important;
    width: 100% !important;
    padding: 0.45rem 0.9rem !important;
    font-size: 0.9rem !important;
    font-weight: 400 !important;
    line-height: 1.5 !important;
    color: #6c757d !important;
    background-color: #fff !important;
    background-clip: padding-box !important;
    border: 1px solid #ced4da !important;
    border-radius: 0.2rem !important;
    transition:
        border-color 0.15s ease-in-out,
        box-shadow 0.15s ease-in-out !important;

    &:focus {
        color: #6c757d !important;
        background-color: #fff !important;
        border-color: #b8c5d1 !important;
        outline: 0 !important;
        box-shadow: none !important;
    }

    &::placeholder {
        color: #adb5bd !important;
        opacity: 1 !important;
    }

    &:disabled,
    &[readonly] {
        background-color: #fff !important;
        opacity: 1 !important;
    }
`;

export default Input;
